<template>
  <div class="d-flex c-gray">
    <div class="mr-2 d-flex align-center">
      <SvgWrapper class="f-clay" use="icon_svg_info_filled" />
    </div>
    <div class="d-flex flex-column">
      <div
        v-html="
          translate('pdp_product_delivery_options_delivered_by', vendorLink)
        "
        :loading="loading"
      ></div>
      <div>
        <span :loading="loading">{{
          translate('fe_app_pdp_product_delivery_days', stock.delivery_time)
        }}</span>
        <span v-if="stock.holiday_to" class="pl-1"
          >|
          {{ translate('new_cart_page_shipping_from', stock.holiday_to) }}</span
        >
        <div v-if="stock.holiday_message">
          {{
            translate(
              'new_cart_page_holiday_message_prefix',
              stock.holiday_message
            )
          }}
        </div>
        <span v-if="stock.min_sale_qty" class="pl-1" v-html="minSaleQty"></span>
        <span v-if="stock.min_sale_qty && stock.min_sale_value"><br /></span>
        <span v-if="stock.min_sale_value" class="pr-1">{{ minSaleValue }}</span>
      </div>
      <Tag
        v-if="stock.express_available"
        class="mt-2"
        :text="translate('pdp_product_delivery_options_express_delivery')"
      />
    </div>
  </div>
</template>

<script>
import { FILTERS, PAGE_URL } from '@/constants/GlobalConstants'
import UtilityHelper from '@/services/helpers/UtilityHelper'
import { defineAsyncComponent } from 'vue'

const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const Tag = defineAsyncComponent(
  () => import('@/components/basic/atoms/Tag.vue')
)

export default {
  components: { Tag, SvgWrapper },
  props: {
    loading: Boolean,
    stock: Object
  },
  computed: {
    vendorLink() {
      const category = (this.translate('fe_app_pdp_wines') || '').toLowerCase()
      const href = UtilityHelper.formatString(
        PAGE_URL.FILTER,
        category,
        FILTERS.IN_STOCK_VENDORS,
        this.stock.name
      )
      return UtilityHelper.formatString(
        '<a class="link-winered" href="%s" target="_blank" rel="noopener">%s</a>',
        href,
        this.stock.name
      )
    },
    minSaleQty() {
      return (
        '| ' +
        this.translate(
          'pdp_information_minimal_order_quantity',
          this.stock.min_sale_qty
        )
      )
    },
    minSaleValue() {
      return (
        (this.stock.min_sale_value ? '| ' : '') +
        this.translate(
          'pdp_information_minimal_order_value',
          this.currency(this.stock.min_sale_value, 2)
        )
      )
    }
  }
}
</script>
